import ipc from '@/renderer/scripts/utils/ipc';
import { IpcEvents } from '@/ipc-events';
import {
  WorkerWindowMsgType,
  WorkerWindowRunAction,
  WorkerWindowReadyInfo,
  WorkerWindowAbendInfo,
  WorkerWindowMsgInfo,
  CreateWorkerProcessBaseData,
} from '@/common/workerWindowDataDefine';
import EventEmitter from '@/common/EventEmitter';
import { CoWorkerProcessInfo, ReportEventName } from '@/common/reporter/eventDef';

/**
 * @description 工作进程工具类，缓存工作进程窗口id
 * @export
 * @class WorkerProcessHelper
 * @extends {EventEmitter}
 */
export default class WorkerProcessHelper extends EventEmitter {
  private workerIdSet = new Set<number>();

  /**
   * @description 创建新的工作进程
   * @param {WorkerWindowRunAction} runAction
   * @param {*} data
   * @return {*}  {Promise<number>}
   * @memberof WorkerProcessHelper
   */
  async creatWorkerProcess<T extends CreateWorkerProcessBaseData>(
    runAction: WorkerWindowRunAction,
    data: T,
  ): Promise<number> {
    const workerWebContentsId = await ipc.invoke(IpcEvents.WORKER_WINDOW_CREATE, {
      runAction,
      param: data,
    });

    if (workerWebContentsId) {
      this.workerIdSet.add(workerWebContentsId);
      if (this.workerIdSet.size === 1) {
        this.initListenter();
      }
    }
    return workerWebContentsId;
  }

  /**
   * @description 销毁某个工作进程
   * @param {number} workerWebContentsId
   * @return {*}  {Promise<boolean>}
   * @memberof WorkerProcessHelper
   */
  async destoryWorkerProcess(workerWebContentsId: number): Promise<boolean> {
    this.workerIdSet.delete(workerWebContentsId);
    if (this.workerIdSet.size === 0) {
      this.unInitListenter();
    }
    return ipc.invoke(IpcEvents.WORKER_WINDOW_DESTORY, { WebContentsId: workerWebContentsId });
  }

  private onWindowDataNotify = (e: any, info: WorkerWindowMsgInfo) => {
    if (!this.workerIdSet.has(info.workerWebContentsId)) {
      logger.ui.info('onWindowDataNotify no workerWebContentsId', info);
      return;
    }

    logger.ui.info('WORKER_WINDOW_DATA_NOTIFY', info);
    switch (info.type) {
      case WorkerWindowMsgType.TYPE_WORKER_WINDOW_READY:
        this.onReadyNotify(info);
        break;
      case WorkerWindowMsgType.TYPE_ABEND:
        this.onAbendNotify(info);
        break;
      default:
        console.log('testSyncDrive no find', info);
    }
  };

  private initListenter() {
    ipc.on(IpcEvents.WORKER_WINDOW_DATA_NOTIFY, this.onWindowDataNotify);
  }

  private unInitListenter() {
    ipc.off(IpcEvents.WORKER_WINDOW_DATA_NOTIFY, this.onWindowDataNotify);
  }

  private onReadyNotify(info: WorkerWindowReadyInfo) {
    if (!this.workerIdSet.has(info.workerWebContentsId)) {
      return;
    }
    this.emit(WorkerWindowMsgType.TYPE_WORKER_WINDOW_READY, info);
  }

  private onAbendNotify(info: WorkerWindowAbendInfo) {
    if (!this.workerIdSet.has(info.workerWebContentsId)) {
      return;
    }
    this.emit(WorkerWindowMsgType.TYPE_ABEND, info);

    const data: CoWorkerProcessInfo = {
      processName: info.workerName || '',
      crashReason: info.reason,
      unResponsive: false,
    };
    reporter.report(ReportEventName.CoWorkerProcessInfo, data);
  }
}
